import { Mark } from '@tiptap/core';

export const FontSize = Mark.create({
  name: 'fontSize',

  addAttributes() {
    return {
      size: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        style: 'font-size',
        getAttrs: value => ({ size: value }),
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', { style: `font-size: ${HTMLAttributes.size}` }, 0]
  },

  addCommands() {
    return {
      setFontSize:
        size =>
        ({ chain }) => {
          return chain().setMark(this.name, { size }).run()
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().unsetMark(this.name).run()
        },
    }
  },
})
